// extracted by mini-css-extract-plugin
export default {"form":"RegisterPage_form__OELhF","errorBox":"RegisterPage_errorBox__4N8hG","errorText":"RegisterPage_errorText__I2BhH"};